import { render, staticRenderFns } from "./RouteCardDetails.vue?vue&type=template&id=8a5f45ce&"
import script from "./RouteCardDetails.vue?vue&type=script&lang=js&"
export * from "./RouteCardDetails.vue?vue&type=script&lang=js&"
import style0 from "./RouteCardDetails.vue?vue&type=style&index=0&id=8a5f45ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports